import React from 'react';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';

const CustomTextField = props => {
  const {
    input,
    label,
    type,
    symbol,
    meta: { touched, error },
    ...other
  } = props;

  return (
    <div>
      <label>{label}</label>
      <div>
        <TextField
          error={!!(touched && error)}
          helperText={touched && error}
          label={symbol}
          style={{
            textAlign: 'left',
            backgroundColor: 'rgba(255,255,255,0.2)',
            borderRadius: 28,
          }}
          type={type}
          {...input}
          {...other}
        />
        <br />
        <br />
      </div>
    </div>
  );
};

CustomTextField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  label: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  type: PropTypes.string,
  currencySymbol: PropTypes.string,
  symbol: PropTypes.string,
};
export default CustomTextField;
